import React, { useEffect } from 'react';

import ConfirmModal from '../../Components/ConfirmModal';
import { useModal } from '../Common';

import useInteractBlocker from './useInteractBlocker';

export default () => {
  const interactBlocker = useInteractBlocker(
    ({ currentLocation, nextLocation }) =>
      currentLocation.pathname !== nextLocation.pathname,
  );

  const [blocker, blockerControls] = interactBlocker;

  const [openConfirmationModal, closeConfirmationModal] = useModal(() => {
    const onClose = () => {
      blocker.reset?.();
      closeConfirmationModal();
    };
    const onConfirm = () => {
      blockerControls.allowNextNavigation();
      blocker.proceed?.();
      closeConfirmationModal();
    };
    return (
      <ConfirmModal
        onConfirm={onConfirm}
        onCancel={onClose}
        onClose={onClose}
        hideCloseIcon
        shouldCloseOnOverlayClick={false}
      >
        <p>All changes will be lost.</p>
        <p>Are you sure you want to continue?</p>
      </ConfirmModal>
    );
  }, [blocker, blockerControls]);

  useEffect(() => {
    if (blocker.state === 'blocked') {
      if (blockerControls.allowNavigateRef.current) {
        return;
      }

      openConfirmationModal();
    }
  }, [blocker.state, blockerControls.allowNavigateRef, openConfirmationModal]);

  return interactBlocker;
};
